import type { Ceviri } from "../tip";
import type { hareketler as tr } from "../tr/hareketler";

/** English dictionary · hareketler. */
export const hareketler: Ceviri<typeof tr> = {
  ekran: {
    baslik: "Transactions",
    aciklama: "The raw record of investment transactions. Deleted records are not listed.",
    yenileniyor: "Refreshing",
    hareketEkle: "Add transaction",
    filtreler: "Transaction filters",
    hesap: "Account",
    tur: "Type",
    ara: "Search asset / note",
    araIpucu: "Searches the visible page only.",
    araOrnek: "THYAO, gold…",
    filtreleriTemizle: "Clear filters",
    yukleniyor: "Loading transactions…",
    filtreyeUyanYok: "No transactions match this filter",
    henuzYok: "No transactions yet",
    filtreleriGevset: "Loosen or clear the filters.",
    henuzYokMetin: "Buys, sells, dividends, money in and out — all are kept here.",
    ilkHareket: "Add the first transaction",
    liste: "Transaction list",
    tarih: "Date",
    varlik: "Asset",
    miktar: "Quantity",
    fiyatTutar: "Price / amount",
    masraf: "Fee",
    vergi: "Tax",
    islem: "Action",
    izlenen: "tracked",
    elle: "manual",
    saltOkunur: "This account is read-only (Subscription).",
    sayfalama: "Pagination",
    toplamOnEk: "Total ",
    kayitSayfa: (toplam) => (toplam === 1 ? " record · page" : " records · page"),
    aramaSatir: (n) => ` · ${n} rows on this page match the search`,
    sayfaBoyu: "Page size",
    onceki: "Previous",
    sonraki: "Next",
    hareketiDuzenle: "Edit transaction",
    formAciklama: "Fields change with the transaction type.",
    silOnayBaslik: "Delete transaction?",
    silOnayMetin: "The record is not physically deleted; it is marked as deleted (tombstone) and removed from the list.",
  },
  form: {
    hesapSecin: "Choose an account.",
    tarihZorunlu: "Trade date is required.",
    valorOnce: "The value date cannot be before the trade date.",
    paraBirimiSecin: "Choose a currency from the list.",
    kimlikZorunlu: "Instrument ID is required.",
    etiketZorunlu: "Asset label is required.",
    vergiYili: "Enter the year the tax belongs to (e.g. 2025).",
    alinanFarkli: "The received currency must differ from the given one.",
    cekmeNotu: "Sale proceeds withdrawn",
    hesap: "Account",
    onceHesap: "Add an account first",
    hareketTuru: "Transaction type",
    paraBirimi: "Currency",
    islemTarihi: "Trade date",
    valor: "Value date",
    valorNakit: "The day the money reaches the account; the exchange rate is taken from this day. If empty, the trade date.",
    valorTakas: "Settlement date. May be left empty.",
    birimFiyat: "Unit price",
    alinanParaBirimi: "Received currency",
    alinanTutar: "Received amount",
    masraf: "Fee",
    vergiStopaj: "Tax / withholding tax",
    kurElle: "Exchange rate (manual)",
    kurElleIpucu: "To override the CBRT exchange rate. Leave empty.",
    nakitNotu: "Cash transaction: linked by default to a manually labelled cash asset.",
    temettuden: "Bought with dividends (reinvestment)",
    temettudenMetin:
      "Counts in cost; does not count in the denominator of “lifetime return %” (money out of pocket). If only part of the buy came from dividends, do not tick this, or split the buy in two.",
    aitYil: "Tax year",
    kaynak: "Source",
    kaynakNakit: "From cash in the account",
    kaynakDisaridan: "From outside (paid without passing through the account; counts as money in)",
    paraCektim: "I withdrew the money",
    paraCektimMetin: "A withdrawal for the net proceeds of the sale is created on the same day.",
    not: "Note",
    nasilBaslik: "How this type is recorded",
    nasilOnce: "The contract's ",
    nasilTip: ' type has no separate "amount" field. Cash transactions are written as',
    nasilMiktar: " quantity = 1",
    nasilVirgul: ", ",
    nasilBirimFiyat: "unit price = amount",
    nasilSonra: '; so the rule "gross = quantity × price" holds for every type.',
    varlikSiniri: "Adding a new asset to this account",
  },
  sekil: {
    miktar: "Quantity",
    alimSatimIpucu: "Gross amount = quantity × unit price. Fee and tax go in separate fields.",
    tutar: "Amount",
    nakitIpucu: "Cash transaction: no quantity/price, only the amount is entered.",
    miktarFarki: "Quantity change",
    miktarFarkiIpucu: "Enter the change in quantity, not the ratio (increase positive, decrease negative).",
    alinanMiktar: "Quantity received",
    ruchanIpucu: "Rights issue subscription: quantity received and unit price paid.",
    gelenMiktar: "Quantity in",
    devirGirisIpucu: "Transfer in from another institution. Enter the unit cost if known; not required.",
    cikanMiktar: "Quantity out",
    devirCikisIpucu: "Transfer out to another institution. Enter the unit cost if known; not required.",
    bolunmeIpucu: "Change in quantity after the split.",
    bedelsizMiktar: "Bonus shares received",
    bedelsizIpucu: "Bonus shares in.",
    netTutar: "Net amount",
    temettuIpucu: "A dividend is cash in: choose the asset it came from and enter the amount.",
    faizTutari: "Interest amount",
    faizIpucu: "Interest/coupon income.",
    yatanTutar: "Amount deposited",
    yatirmaIpucu: "Money into the account.",
    cekilenTutar: "Amount withdrawn",
    cekmeIpucu: "Money out of the account.",
    masrafTutari: "Fee amount",
    masrafIpucu: "Commission, custody fee, stamp duty.",
    odenenTutar: "Amount paid",
    vergiIpucu: "Tax paid on a return. Tax due is not estimated; only the payment you made.",
    verilenTutar: "Amount given",
    dovizIpucu:
      "Switching from one currency to another within the same account: not counted as money in or out. Enter the given and received amounts as on the statement; the exchange rate is their ratio.",
  },
  secim: {
    soru: (n) => `What should happen to the ${n} ${n === 1 ? "transaction" : "transactions"} in this account?`,
    sil: "Delete the transactions too",
    tasi: "Move them to another account — counted as if they had always been there",
    hedefYok: "There is no other account to move them to.",
    hedef: "Target account",
    hesapSecin: "Choose an account",
  },
  nakitTakibi: {
    kendiliginden: "Automatic (on if there are deposits/withdrawals)",
    acik: "On",
    kapali: "Off",
  },
  deneme: {
    saniye: (n) => `${n} ${n === 1 ? "second" : "seconds"}`,
    dakika: (n) => `${n} ${n === 1 ? "minute" : "minutes"}`,
    bekleme: (sure) => `Too many wrong attempts in a row: try again in ${sure}.`,
  },
};
